/** Mirrors `src/config/roles.js` for v2-only modules (avoids cross-root imports). */

export const ROLES = {
  FINANCE: 'finance',
  RMG: 'rmg',
  ADMIN: 'admin',
} as const

export const DEFAULT_ROLE = ROLES.FINANCE

export const VALID_ROLES = Object.values(ROLES) as string[]

const ROLE_DISPLAY_NAMES: Record<string, string> = {
  [ROLES.ADMIN]: 'Admin',
  [ROLES.FINANCE]: 'Finance',
  [ROLES.RMG]: 'RMG',
}

export function formatRoleDisplay(role: string): string {
  return ROLE_DISPLAY_NAMES[role] || role || ''
}
